module.exports = __webpack_public_path__ + "img/template.9c398725.png";